import { Box, Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';

import Cross from 'components/Icons/Cross';
import GridView from 'components/Icons/GridView';
import TableView from 'components/Icons/TableView';
import { setDriver } from 'redux/PlanPageSlice';
import { AppDispatch } from 'utils/GlobalHelpers';

import DesktopPanel from '../ItemPage/DesktopPanel';
import TableViewComponent from '../ItemPage/DesktopPanel/TableView';

interface Properties {
  longClickCheck: any;
  isLongClicked: boolean;
  refetchRequest: () => void;
  orgChartType: number;
  updateOrg: (type: number) => void;
}

const LegacyOrganisationPanel = ({
  longClickCheck,
  isLongClicked,
  refetchRequest,
  orgChartType,
  updateOrg,
}: Properties) => {
  const dispatch: AppDispatch = useDispatch();

  const closeSection = () => {
    dispatch(setDriver(null));
  };

  return (
    <Box height='100%'>
      <Flex justifyContent='space-between'>
        <Box display='flex' justifyContent='flex-end' padding='1rem'>
          <button type='button' onClick={() => updateOrg(2)}>
            <TableView selected={orgChartType === 2} />
          </button>
          <button type='button' onClick={() => updateOrg(1)}>
            <GridView selected={orgChartType === 1} />
          </button>
        </Box>
        <Flex justifyContent='end' padding='1rem'>
          <Cross onClick={closeSection} />
        </Flex>
      </Flex>
      {orgChartType === 1 ? (
        <TableViewComponent refetchRequest={refetchRequest} />
      ) : (
        <DesktopPanel
          orgType
          longClickCheck={longClickCheck}
          isLongClicked={isLongClicked}
          refetchRequest={refetchRequest}
        />
      )}
    </Box>
  );
};

export default LegacyOrganisationPanel;
